export const url = "http://127.0.0.1:8000";
// export const url = "https://spacemate.pythonanywhere.com";
// export const url = "https://www.spacemate.in";


